/** @format */

import React, { useState } from 'react'
import { _$, Tabs, Tab, Card } from 'kpc-react'
import TacticsList from 'src/containers/MonitorAlarmTactics/TacticsList'
import EventList from 'src/containers/MonitorAlarmTactics/AlarmEventList'
import MonitorCrumb from 'src/components/MonitorCrumb'

// 告警策略
const TacticsTabs = [
  {
    text: '阈值告警',
    value: 'threshold'
  },
  {
    text: '事件告警',
    value: 'event'
  }
]
const MonitorAlarmTactics = () => {
  const [currentTab, setTab] = useState('threshold')

  return (
    <>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('告警策略') }]} />
      <Card>
        <Tabs value={currentTab} on$change-value={(c, tab) => setTab(tab)}>
          {TacticsTabs.map(({ text, value }) => (
            <Tab key={value} value={value}>
              {_$(text)}
            </Tab>
          ))}
        </Tabs>
        <div>{currentTab === 'threshold' ? <TacticsList /> : <EventList />}</div>
      </Card>
    </>
  )
}

export default MonitorAlarmTactics
